export type WeekdayNumber	= typeof WeekdayNumber.values[number];

// starting at monday with 1
export namespace WeekdayNumber {
	// takes 0..6 for sunday to monday, returns 1..7 for monday to sunday
	export const fromSundayBasedIndex	= (day:number):WeekdayNumber	=>
		(day + 6) % 7 + 1 as WeekdayNumber;

	export const values	= [ 1, 2, 3, 4, 5, 6, 7 ] as const;
};
